import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d17c9020")

_pushScopeId("data-v-d17c9020")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "HR Admin")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_ctx.userInfoData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_GroupContainer, null, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              text: "Add User",
              to: "/hr-admin/add-user",
              disabled: _ctx.userInfoData.isHRAdminReadOnly
            }, null, 8, ["disabled"]),
            _createVNode(_component_Button, {
              text: "View/Edit User",
              to: "/hr-admin/user"
            }),
            _createVNode(_component_Button, {
              text: "Generate Reports",
              to: "/hr-admin/reports"
            }),
            (_ctx.bannerUploadAccess)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  text: "Banner Upload",
                  to: "/hr-admin/banner-upload"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
})